module.exports = __webpack_public_path__ + "static/media/Velke_Bilovice.fc676551.md";